var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._l((_vm.active),function(ref){
var id = ref.id;
var priority = ref.priority;
var type = ref.type;
return [_c('reaction-live-entity',{key:id,attrs:{"type":type,"delay":priority * _vm.delay},on:{"entered":function($event){return _vm.handleEntityEntered(id)}}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }